import _defineProperty from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Utility module to work with strings.
 *
 * @module string
 */

/**
 * @param {string} s
 * @return {string}
 */
var toLowerCase = function toLowerCase(s) {
  return s.toLowerCase();
};

var trimLeftRegex = /^\s*/g;
/**
 * @param {string} s
 * @return {string}
 */

var trimLeft = function trimLeft(s) {
  return s.replace(trimLeftRegex, '');
};

var fromCamelCaseRegex = /([A-Z])/g;
/**
 * @param {string} s
 * @param {string} separator
 * @return {string}
 */

var fromCamelCase = function fromCamelCase(s, separator) {
  return trimLeft(s.replace(fromCamelCaseRegex, function (match) {
    return "".concat(separator).concat(toLowerCase(match));
  }));
};
/**
 * @param {string} str
 * @return {Uint8Array}
 */


var _encodeUtf8Polyfill = function _encodeUtf8Polyfill(str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  var buf = new Uint8Array(len);

  for (var i = 0; i < len; i++) {
    buf[i] =
    /** @type {number} */
    encodedString.codePointAt(i);
  }

  return buf;
};
/* c8 ignore next */


var utf8TextEncoder =
/** @type {TextEncoder} */
typeof TextEncoder !== 'undefined' ? new TextEncoder() : null;
/**
 * @param {string} str
 * @return {Uint8Array}
 */

var _encodeUtf8Native = function _encodeUtf8Native(str) {
  return utf8TextEncoder.encode(str);
};
/**
 * @param {string} str
 * @return {Uint8Array}
 */

/* c8 ignore next */


var encodeUtf8 = utf8TextEncoder ? _encodeUtf8Native : _encodeUtf8Polyfill;
/* c8 ignore next */

var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf-8', {
  fatal: true,
  ignoreBOM: true
});
/* c8 ignore start */

if (utf8TextDecoder && utf8TextDecoder.decode(new Uint8Array()).length === 1) {
  // Safari doesn't handle BOM correctly.
  // This fixes a bug in Safari 13.0.5 where it produces a BOM the first time it is called.
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the first call and
  // utf8TextDecoder.decode(new Uint8Array()).length === 1 on the second call
  // Another issue is that from then on no BOM chars are recognized anymore

  /* c8 ignore next */
  utf8TextDecoder = null;
}
/**
 * Utility module to work with key-value stores.
 *
 * @module map
 */

/**
 * Creates a new Map instance.
 *
 * @function
 * @return {Map<any, any>}
 *
 * @function
 */


var create$1 = function create$1() {
  return new Map();
};
/**
 * Often used conditions.
 *
 * @module conditions
 */

/**
 * @template T
 * @param {T|null|undefined} v
 * @return {T|null}
 */

/* c8 ignore next */


var undefinedToNull = function undefinedToNull(v) {
  return v === undefined ? null : v;
};
/* eslint-env browser */

/**
 * Isomorphic variable storage.
 *
 * Uses LocalStorage in the browser and falls back to in-memory storage.
 *
 * @module storage
 */

/* c8 ignore start */


var VarStoragePolyfill =
/*#__PURE__*/
function () {
  function VarStoragePolyfill() {
    _classCallCheck(this, VarStoragePolyfill);

    this.map = new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */


  _createClass(VarStoragePolyfill, [{
    key: "setItem",
    value: function setItem(key, newValue) {
      this.map.set(key, newValue);
    }
    /**
     * @param {string} key
     */

  }, {
    key: "getItem",
    value: function getItem(key) {
      return this.map.get(key);
    }
  }]);

  return VarStoragePolyfill;
}();
/* c8 ignore stop */

/**
 * @type {any}
 */


var _localStorage = new VarStoragePolyfill();

var usePolyfill = true;
/* c8 ignore start */

try {
  // if the same-origin rule is violated, accessing localStorage might thrown an error
  if (typeof localStorage !== 'undefined') {
    _localStorage = localStorage;
    usePolyfill = false;
  }
} catch (e) {}
/* c8 ignore stop */

/**
 * This is basically localStorage in browser, or a polyfill in nodejs
 */

/* c8 ignore next */


var varStorage = _localStorage;
/**
 * Common functions and function call helpers.
 *
 * @module function
 */

/**
 * @template V
 * @template {V} OPTS
 *
 * @param {V} value
 * @param {Array<OPTS>} options
 */
// @ts-ignore

var isOneOf = function isOneOf(value, options) {
  return options.includes(value);
};
/* c8 ignore stop */

/**
 * Isomorphic module to work access the environment (query params, env variables).
 *
 * @module map
 */

/* c8 ignore next */
// @ts-ignore


var isNode = typeof process !== 'undefined' && process.release && /node|io\.js/.test(process.release.name);
/* c8 ignore next 3 */

typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
/**
 * @type {Map<string,string>}
 */

var params;
/* c8 ignore start */

var computeParams = function computeParams() {
  if (params === undefined) {
    if (isNode) {
      params = create$1();
      var pargs = process.argv;
      var currParamName = null;

      for (var i = 0; i < pargs.length; i++) {
        var parg = pargs[i];

        if (parg[0] === '-') {
          if (currParamName !== null) {
            params.set(currParamName, '');
          }

          currParamName = parg;
        } else {
          if (currParamName !== null) {
            params.set(currParamName, parg);
            currParamName = null;
          }
        }
      }

      if (currParamName !== null) {
        params.set(currParamName, '');
      } // in ReactNative for example this would not be true (unless connected to the Remote Debugger)

    } else if (typeof location === 'object') {
      params = create$1(); // eslint-disable-next-line no-undef

      (location.search || '?').slice(1).split('&').forEach(function (kv) {
        if (kv.length !== 0) {
          var _kv$split = kv.split('='),
              _kv$split2 = _slicedToArray(_kv$split, 2),
              key = _kv$split2[0],
              value = _kv$split2[1];

          params.set("--".concat(fromCamelCase(key, '-')), value);
          params.set("-".concat(fromCamelCase(key, '-')), value);
        }
      });
    } else {
      params = create$1();
    }
  }

  return params;
};
/* c8 ignore stop */

/**
 * @param {string} name
 * @return {boolean}
 */

/* c8 ignore next */


var hasParam = function hasParam(name) {
  return computeParams().has(name);
};
/**
 * @param {string} name
 * @return {string|null}
 */

/* c8 ignore next 4 */


var getVariable = function getVariable(name) {
  return isNode ? undefinedToNull(process.env[name.toUpperCase()]) : undefinedToNull(varStorage.getItem(name));
};
/**
 * @param {string} name
 * @return {boolean}
 */

/* c8 ignore next 2 */


var hasConf = function hasConf(name) {
  return hasParam('--' + name) || getVariable(name) !== null;
};
/* c8 ignore next */


hasConf('production');
/* c8 ignore next 2 */

var forceColor = isNode && isOneOf(process.env.FORCE_COLOR, ['true', '1', '2']);
/* c8 ignore start */

!hasParam('no-colors') && (!isNode || process.stdout.isTTY || forceColor) && (!isNode || hasParam('color') || forceColor || getVariable('COLORTERM') !== null || (getVariable('TERM') || '').includes('color'));
/* c8 ignore stop */

/* eslint-env browser */

var BIT8 = 128;
var BITS7 = 127;
/**
 * Common Math expressions.
 *
 * @module math
 */

var floor = Math.floor;
/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The smaller element of a and b
 */

var min = function min(a, b) {
  return a < b ? a : b;
};
/**
 * @function
 * @param {number} a
 * @param {number} b
 * @return {number} The bigger element of a and b
 */


var max = function max(a, b) {
  return a > b ? a : b;
};
/**
 * Utility helpers for working with numbers.
 *
 * @module number
 */


var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER;
/**
 * Error helpers.
 *
 * @module error
 */

/**
 * @param {string} s
 * @return {Error}
 */

/* c8 ignore next */

var create = function create(s) {
  return new Error(s);
};
/**
 * Efficient schema-less binary decoding with support for variable length encoding.
 *
 * Use [lib0/decoding] with [lib0/encoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module decoding
 */


var errorUnexpectedEndOfArray = create('Unexpected end of array');
var errorIntegerOutOfRange = create('Integer out of Range');
/**
 * Create an Uint8Array view of the next `len` bytes and advance the position by `len`.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder The decoder instance
 * @param {number} len The length of bytes to read
 * @return {Uint8Array}
 */

var readUint8Array = function readUint8Array(decoder, len) {
  var view = createUint8ArrayViewFromArrayBuffer(decoder.arr.buffer, decoder.pos + decoder.arr.byteOffset, len);
  decoder.pos += len;
  return view;
};
/**
 * Read variable length Uint8Array.
 *
 * Important: The Uint8Array still points to the underlying ArrayBuffer. Make sure to discard the result as soon as possible to prevent any memory leaks.
 *            Use `buffer.copyUint8Array` to copy the result into a new Uint8Array.
 *
 * @function
 * @param {Decoder} decoder
 * @return {Uint8Array}
 */


var readVarUint8Array = function readVarUint8Array(decoder) {
  return readUint8Array(decoder, readVarUint(decoder));
};
/**
 * Read one byte as unsigned integer.
 * @function
 * @param {Decoder} decoder The decoder instance
 * @return {number} Unsigned 8-bit integer
 */


var readUint8 = function readUint8(decoder) {
  return decoder.arr[decoder.pos++];
};
/**
 * Read unsigned integer (32bit) with variable length.
 * 1/8th of the storage is used as encoding overhead.
 *  * numbers < 2^7 is stored in one bytlength
 *  * numbers < 2^14 is stored in two bylength
 *
 * @function
 * @param {Decoder} decoder
 * @return {number} An unsigned integer.length
 */


var readVarUint = function readVarUint(decoder) {
  var num = 0;
  var mult = 1;
  var len = decoder.arr.length;

  while (decoder.pos < len) {
    var r = decoder.arr[decoder.pos++]; // num = num | ((r & binary.BITS7) << len)

    num = num + (r & BITS7) * mult; // shift $r << (7*#iterations) and add it to num

    mult *= 128; // next iteration, shift 7 "more" to the left

    if (r < BIT8) {
      return num;
    }
    /* c8 ignore start */


    if (num > MAX_SAFE_INTEGER) {
      throw errorIntegerOutOfRange;
    }
    /* c8 ignore stop */

  }

  throw errorUnexpectedEndOfArray;
};
/**
 * We don't test this function anymore as we use native decoding/encoding by default now.
 * Better not modify this anymore..
 *
 * Transforming utf8 to a string is pretty expensive. The code performs 10x better
 * when String.fromCodePoint is fed with all characters as arguments.
 * But most environments have a maximum number of arguments per functions.
 * For effiency reasons we apply a maximum of 10000 characters at once.
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String.
 */

/* c8 ignore start */


var _readVarStringPolyfill = function _readVarStringPolyfill(decoder) {
  var remainingLen = readVarUint(decoder);

  if (remainingLen === 0) {
    return '';
  } else {
    var encodedString = String.fromCodePoint(readUint8(decoder)); // remember to decrease remainingLen

    if (--remainingLen < 100) {
      // do not create a Uint8Array for small strings
      while (remainingLen--) {
        encodedString += String.fromCodePoint(readUint8(decoder));
      }
    } else {
      while (remainingLen > 0) {
        var nextLen = remainingLen < 10000 ? remainingLen : 10000; // this is dangerous, we create a fresh array view from the existing buffer

        var bytes = decoder.arr.subarray(decoder.pos, decoder.pos + nextLen);
        decoder.pos += nextLen; // Starting with ES5.1 we can supply a generic array-like object as arguments

        encodedString += String.fromCodePoint.apply(null,
        /** @type {any} */
        bytes);
        remainingLen -= nextLen;
      }
    }

    return decodeURIComponent(escape(encodedString));
  }
};
/* c8 ignore stop */

/**
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 */


var _readVarStringNative = function _readVarStringNative(decoder) {
  return (
    /** @type any */
    utf8TextDecoder.decode(readVarUint8Array(decoder))
  );
};
/**
 * Read string of variable length
 * * varUint is used to store the length of the string
 *
 * @function
 * @param {Decoder} decoder
 * @return {String} The read String
 *
 */

/* c8 ignore next */


var readVarString = utf8TextDecoder ? _readVarStringNative : _readVarStringPolyfill;
/**
 * Utility functions to work with buffers (Uint8Array).
 *
 * @module buffer
 */

/**
 * Create Uint8Array with initial content from buffer
 *
 * @param {ArrayBuffer} buffer
 * @param {number} byteOffset
 * @param {number} length
 */

var createUint8ArrayViewFromArrayBuffer = function createUint8ArrayViewFromArrayBuffer(buffer, byteOffset, length) {
  return new Uint8Array(buffer, byteOffset, length);
};
/**
 * Efficient schema-less binary encoding with support for variable length encoding.
 *
 * Use [lib0/encoding] with [lib0/decoding]. Every encoding function has a corresponding decoding function.
 *
 * Encodes numbers in little-endian order (least to most significant byte order)
 * and is compatible with Golang's binary encoding (https://golang.org/pkg/encoding/binary/)
 * which is also used in Protocol Buffers.
 *
 * ```js
 * // encoding step
 * const encoder = encoding.createEncoder()
 * encoding.writeVarUint(encoder, 256)
 * encoding.writeVarString(encoder, 'Hello world!')
 * const buf = encoding.toUint8Array(encoder)
 * ```
 *
 * ```js
 * // decoding step
 * const decoder = decoding.createDecoder(buf)
 * decoding.readVarUint(decoder) // => 256
 * decoding.readVarString(decoder) // => 'Hello world!'
 * decoding.hasContent(decoder) // => false - all data is read
 * ```
 *
 * @module encoding
 */

/**
 * Write one byte to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The byte that is to be encoded.
 */


var write = function write(encoder, num) {
  var bufferLen = encoder.cbuf.length;

  if (encoder.cpos === bufferLen) {
    encoder.bufs.push(encoder.cbuf);
    encoder.cbuf = new Uint8Array(bufferLen * 2);
    encoder.cpos = 0;
  }

  encoder.cbuf[encoder.cpos++] = num;
};
/**
 * Write a variable length unsigned integer. Max encodable integer is 2^53.
 *
 * @function
 * @param {Encoder} encoder
 * @param {number} num The number that is to be encoded.
 */


var writeVarUint = function writeVarUint(encoder, num) {
  while (num > BITS7) {
    write(encoder, BIT8 | BITS7 & num);
    num = floor(num / 128); // shift >>> 7
  }

  write(encoder, BITS7 & num);
};
/**
 * A cache to store strings temporarily
 */


var _strBuffer = new Uint8Array(30000);

var _maxStrBSize = _strBuffer.length / 3;
/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */


var _writeVarStringNative = function _writeVarStringNative(encoder, str) {
  if (str.length < _maxStrBSize) {
    // We can encode the string into the existing buffer

    /* c8 ignore next */
    var written = utf8TextEncoder.encodeInto(str, _strBuffer).written || 0;
    writeVarUint(encoder, written);

    for (var i = 0; i < written; i++) {
      write(encoder, _strBuffer[i]);
    }
  } else {
    writeVarUint8Array(encoder, encodeUtf8(str));
  }
};
/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */


var _writeVarStringPolyfill = function _writeVarStringPolyfill(encoder, str) {
  var encodedString = unescape(encodeURIComponent(str));
  var len = encodedString.length;
  writeVarUint(encoder, len);

  for (var i = 0; i < len; i++) {
    write(encoder,
    /** @type {number} */
    encodedString.codePointAt(i));
  }
};
/**
 * Write a variable length string.
 *
 * @function
 * @param {Encoder} encoder
 * @param {String} str The string that is to be encoded.
 */

/* c8 ignore next */


var writeVarString = utf8TextEncoder &&
/** @type {any} */
utf8TextEncoder.encodeInto ? _writeVarStringNative : _writeVarStringPolyfill;
/**
 * Append fixed-length Uint8Array to the encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */

var writeUint8Array = function writeUint8Array(encoder, uint8Array) {
  var bufferLen = encoder.cbuf.length;
  var cpos = encoder.cpos;
  var leftCopyLen = min(bufferLen - cpos, uint8Array.length);
  var rightCopyLen = uint8Array.length - leftCopyLen;
  encoder.cbuf.set(uint8Array.subarray(0, leftCopyLen), cpos);
  encoder.cpos += leftCopyLen;

  if (rightCopyLen > 0) {
    // Still something to write, write right half..
    // Append new buffer
    encoder.bufs.push(encoder.cbuf); // must have at least size of remaining buffer

    encoder.cbuf = new Uint8Array(max(bufferLen * 2, rightCopyLen)); // copy array

    encoder.cbuf.set(uint8Array.subarray(leftCopyLen));
    encoder.cpos = rightCopyLen;
  }
};
/**
 * Append an Uint8Array to Encoder.
 *
 * @function
 * @param {Encoder} encoder
 * @param {Uint8Array} uint8Array
 */


var writeVarUint8Array = function writeVarUint8Array(encoder, uint8Array) {
  writeVarUint(encoder, uint8Array.byteLength);
  writeUint8Array(encoder, uint8Array);
};

var AuthMessageType;

(function (AuthMessageType) {
  AuthMessageType[AuthMessageType["Token"] = 0] = "Token";
  AuthMessageType[AuthMessageType["PermissionDenied"] = 1] = "PermissionDenied";
  AuthMessageType[AuthMessageType["Authenticated"] = 2] = "Authenticated";
})(AuthMessageType || (AuthMessageType = {}));

var writeAuthentication = function writeAuthentication(encoder, auth) {
  writeVarUint(encoder, AuthMessageType.Token);
  writeVarString(encoder, auth);
};

var writePermissionDenied = function writePermissionDenied(encoder, reason) {
  writeVarUint(encoder, AuthMessageType.PermissionDenied);
  writeVarString(encoder, reason);
};

var writeAuthenticated = function writeAuthenticated(encoder, scope) {
  writeVarUint(encoder, AuthMessageType.Authenticated);
  writeVarString(encoder, scope);
};

var readAuthMessage = function readAuthMessage(decoder, permissionDeniedHandler, authenticatedHandler) {
  switch (readVarUint(decoder)) {
    case AuthMessageType.PermissionDenied:
      {
        permissionDeniedHandler(readVarString(decoder));
        break;
      }

    case AuthMessageType.Authenticated:
      {
        authenticatedHandler(readVarString(decoder));
        break;
      }
  }
};
/**
 * The server is terminating the connection because a data frame was received
 * that is too large.
 * See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent/code
 */


var MessageTooBig = {
  code: 1009,
  reason: 'Message Too Big'
};
/**
 * The server successfully processed the request, asks that the requester reset
 * its document view, and is not returning any content.
 */

var ResetConnection = {
  code: 4205,
  reason: 'Reset Connection'
};
/**
 * Similar to Forbidden, but specifically for use when authentication is required and has
 * failed or has not yet been provided.
 */

var Unauthorized = {
  code: 4401,
  reason: 'Unauthorized'
};
/**
 * The request contained valid data and was understood by the server, but the server
 * is refusing action.
 */

var Forbidden = {
  code: 4403,
  reason: 'Forbidden'
};
/**
 * The server timed out waiting for the request.
 */

var ConnectionTimeout = {
  code: 4408,
  reason: 'Connection Timeout'
};

var awarenessStatesToArray = function awarenessStatesToArray(states) {
  return Array.from(states.entries()).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return _objectSpread({
      clientId: key
    }, value);
  });
};
/**
 * State of the WebSocket connection.
 * https://developer.mozilla.org/de/docs/Web/API/WebSocket/readyState
 */


var WsReadyStates;

(function (WsReadyStates) {
  WsReadyStates[WsReadyStates["Connecting"] = 0] = "Connecting";
  WsReadyStates[WsReadyStates["Open"] = 1] = "Open";
  WsReadyStates[WsReadyStates["Closing"] = 2] = "Closing";
  WsReadyStates[WsReadyStates["Closed"] = 3] = "Closed";
})(WsReadyStates || (WsReadyStates = {}));

export { ConnectionTimeout, Forbidden, MessageTooBig, ResetConnection, Unauthorized, WsReadyStates, awarenessStatesToArray, readAuthMessage, writeAuthenticated, writeAuthentication, writePermissionDenied };